<template>
  <v-dialog v-model="dialog" width="350">
    <v-card>
      <v-toolbar color="red-darken-3">
        <v-spacer />

        <v-btn
          variant="outlined"
          icon
          size="small"
          color="white"
          @click="dialog = false"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p>
          {{ $t("price.initial_price") }}:
          <strong>
            {{ price.initial_price }}
          </strong>
        </p>
        <p v-if="discountResult?.isDiscounted">
          {{ $t("price.discount_percentage") }} RR:
          <strong> {{ rrDiscount }} ({{ rrDiscount * 100 }} %) </strong>
        </p>

        <p v-if="discountResult?.isDiscounted">
          {{ $t("price.rr_fee") }}:
          <strong> {{ rrFee }} ({{ (rrFee * 100).toFixed(0) }} %) </strong>
        </p>
        <p v-if="discountResult?.isDiscounted">
          {{ $t("price.shipping_cost") }}:
          <strong> {{ shippingCost }} </strong>
        </p>
        <p v-if="!discountResult?.isDiscounted">
          {{ $t("price.discounted_price") }}:
          <strong>
            {{ price.discounted_price }}
          </strong>
        </p>
        <p v-if="!discountResult?.isDiscounted">
          {{ $t("price.discount_percentage") }}:

          <strong> {{ price.discount_percentage }}% </strong>
        </p>
        <p>
          {{ $t("price.final_price") }}:
          <strong>
            {{ discountResult?.finalPrice }}
          </strong>
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    price: null,
    rrDiscount: null,
    rrFee: null,
    finalPrice: null,
    shippingCost: null,
    discountResult: null,
  }),
  //   watch: {
  //     dialog(value) {
  //       if (!value) {
  //         this.price = {};
  //       }
  //     },
  //   },
  methods: {
    async open(item) {
      this.price = item.order.id.price;

      this.discountResult = this.calculateDiscountedPrice(
        item.order.id.price.initial_price,
        item,
      );

      this.dialog = true;
    },

    calculateDiscountedPrice(originalPrice, item) {
      if (
        !item.order ||
        !item.order.id ||
        !item.order.id.origin ||
        !item.institution_id
      ) {
        return { finalPrice: originalPrice, discount: 0, isDiscounted: false };
      }

      const price = parseFloat(originalPrice);

      // Same conditions you used before
      const isEligibleOrigin =
        item.order && item.order.id && item.order.id.origin !== "whatsapp";

      const isEligibleInstitution =
        item.institution_id && item.institution_id.rrMember === true;

      // If not eligible → no discount
      if (!isEligibleOrigin || !isEligibleInstitution) {
        return {
          finalPrice: price.toFixed(2),
          discount: 0,
          isDiscounted: false,
        };
      }
      // -------------------------
      // NEW %RR RULES
      // -------------------------
      let rrPercent = 0;

      if (price >= 0 && price <= 299) {
        rrPercent = 20;
      } else if (price >= 300 && price <= 999) {
        rrPercent = 15;
      } else if (price >= 1000 && price <= 1999) {
        rrPercent = 10;
      } else if (price >= 2000) {
        rrPercent = 5;
      }

      // Convert % to decimals
      const rrDiscount = rrPercent / 100;
      this.rrDiscount = rrDiscount;
      this.rrFee = 0.07;
      // -------------------------
      // NEW PRICE FORMULA
      // Prezzo tot - %RR + 7% + spedizione
      // -------------------------

      const shipping =
        item.shippingCosts && item.shippingCosts.rr
          ? parseFloat(item.shippingCosts.rr)
          : 0;
      this.shippingCost = shipping;
      const finalPrice = price - price * rrDiscount + price * 0.07 + shipping;
      this.finalPrice = finalPrice;
      return {
        finalPrice: finalPrice.toFixed(2),
        discount: rrPercent, // same variable name
        isDiscounted: rrPercent > 0,
      };
    },
  },
};
</script>
